// extracted by mini-css-extract-plugin
export default {"tag":"statusTag_tag__EEYou"};